import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm } from 'formik-antd';
import {
  AddressAutoCompleteForm,
  useAddressData,
} from 'components/address-auto-complete';

import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import StagePropTypes from './prop-types';
import { DB_PREFIX } from './constants';

const tooltipText = `
Post codes are used to assist in providing you and potential employers with opportunities close to your home address.
`;

const Form = ({ values, setFieldValue, children }) => {
  const {
    [DB_PREFIX]: { postCode },
  } = values;

  const handleAddressData = useAddressData({
    setFieldValue,
    prefix: `${DB_PREFIX}.`,
  });

  return (
    <FormikForm layout="vertical">
      <AddressAutoCompleteForm
        prefix={`${DB_PREFIX}.`}
        input={postCode}
        setAddressData={handleAddressData}
        postCodeLabel={
          <span>
            Post Code&nbsp;
            <Tooltip title={tooltipText}>
              <QuestionCircleOutlined />
            </Tooltip>
          </span>
        }
      />

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

Form.defaultProps = {
  children: null,
};

export default Form;
